"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModalButtonContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledModalButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "ChoiceModalstyles__StyledModalButtonContainer",
  componentId: "sc-1kzmy8v-0"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;> *{flex:1 1 50%;.c-alert-choice-modal-negative-button{margin-right:2rem;}}.c-alert-choice-modal-link-button-container{width:100%;display:flex;justify-content:center;align-content:center;align-items:center;}"]);

exports.StyledModalButtonContainer = StyledModalButtonContainer;